import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getTodayTip, ETIQUETTE_CATEGORIES } from "../../../mocks/etiquette";

export default function EtiquetteTipCard() {
  const navigate = useNavigate();
  const tip = getTodayTip();
  const cat = ETIQUETTE_CATEGORIES.find(c => c.key === tip.category);
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="bg-[#111112] border border-white/[0.07] rounded-xl overflow-hidden">
      {/* Header */}
      <div className="px-4 py-3 border-b border-white/[0.05] flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 flex items-center justify-center rounded bg-amber-500/15 border border-amber-500/20">
            <i className="ri-medal-line text-amber-400/80 text-xs"></i>
          </div>
          <span className="text-[#888888] text-[11px] font-medium">오늘의 비즈니스 예절 팁</span>
        </div>
        <button
          type="button"
          onClick={() => navigate("/etiquette")}
          className="text-[#4B6CF7]/70 text-[10px] hover:text-[#7A9BFF] transition-colors cursor-pointer whitespace-nowrap"
        >
          전체 보기 →
        </button>
      </div>

      {/* Content */}
      <div className="px-4 py-3">
        <div className="flex items-center gap-2 mb-2">
          {cat && (
            <div className="flex items-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center rounded" style={{ background: cat.color + "18" }}>
                <i className={`${cat.icon} text-[9px]`} style={{ color: cat.color }}></i>
              </div>
              <span className="text-[10px]" style={{ color: cat.color + "BB" }}>{cat.label}</span>
            </div>
          )}
        </div>

        <p className="text-[#CCCCCC] text-xs font-semibold mb-1.5 leading-snug">{tip.title}</p>
        <p className="text-[#666666] text-[11px] leading-relaxed">{tip.summary}</p>

        {expanded && (
          <div className="mt-3 space-y-2.5 animate-[fadeIn_0.2s_ease]">
            <p className="text-[#888888] text-[11px] leading-relaxed border-t border-white/[0.05] pt-2.5">{tip.detail}</p>
            <div className="grid grid-cols-2 gap-2">
              <div className="bg-emerald-400/[0.04] border border-emerald-400/12 rounded-lg p-2.5">
                <p className="text-emerald-400/70 text-[9px] font-semibold mb-1.5 uppercase tracking-wider">이렇게 하세요</p>
                {tip.doList.slice(0, 2).map((d, i) => (
                  <p key={i} className="text-[#777777] text-[10px] leading-snug mb-1 flex items-start gap-1">
                    <span className="text-emerald-400/50 shrink-0 mt-px">✓</span>{d}
                  </p>
                ))}
              </div>
              <div className="bg-red-400/[0.04] border border-red-400/12 rounded-lg p-2.5">
                <p className="text-red-400/70 text-[9px] font-semibold mb-1.5 uppercase tracking-wider">이건 피하세요</p>
                {tip.dontList.slice(0, 2).map((d, i) => (
                  <p key={i} className="text-[#777777] text-[10px] leading-snug mb-1 flex items-start gap-1">
                    <span className="text-red-400/50 shrink-0 mt-px">✗</span>{d}
                  </p>
                ))}
              </div>
            </div>
          </div>
        )}

        <button
          type="button"
          onClick={() => setExpanded(v => !v)}
          className="mt-2.5 text-[10px] text-[#444444] hover:text-[#888888] transition-colors cursor-pointer flex items-center gap-1"
        >
          {expanded ? <><i className="ri-arrow-up-s-line"></i>접기</> : <><i className="ri-arrow-down-s-line"></i>자세히 보기</>}
        </button>
      </div>
    </div>
  );
}
